import { gql } from '@apollo/client'

export const UPDATE_HEALTH_DATA = gql`
  mutation updateHealthData($healthData: HealthKitData!) {
    updateHealthData(healthData: $healthData) {
      success
    }
  }
`
